import { connect } from 'react-redux';
import TinyAuditLog from '../views/tiny/TinyAuditLog';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, () => ({}))(TinyAuditLog);
